import React from 'react';
import { Tabs } from 'antd';
import { isExternalContributorOrExternalView } from '../../utils/UserInfo';
import { projectStatusMap } from '../../components/ProjectStatusMap';

const TabPane = Tabs.TabPane;
const padfix = {
  margin: '16px 16px 5px 16px',
  border: '1px solid #f0f0f0',
};
function ChecklistTabs({
  parsedFilterSelectionsJson,
  history,
  match,

  activeTabKey,
}) {
  return (
    <>
      <Tabs
        centered
        defaultActiveKey={
          isExternalContributorOrExternalView()
            ? 'active'
            : parsedFilterSelectionsJson &&
              parsedFilterSelectionsJson.selectedDefaultDashView
            ? projectStatusMap[
                parsedFilterSelectionsJson.selectedDefaultDashView
              ]
            : parsedFilterSelectionsJson &&
              !parsedFilterSelectionsJson.selectedDefaultDashView
            ? 'all'
            : 'upcoming'
        }
        //  defaultActiveKey={(isExternalContributorOrExternalView() ? "active" : 'upcoming')}
        onTabClick={(key) =>
          history.push({
            pathname: `/dashboard/${key}`,
            state: {
              station: '',
              status: '',
              activeTabKey: key,
            },
          })
        }
        activeKey={
          match.params.tabId ||
          (isExternalContributorOrExternalView() ? 'active' : activeTabKey)
        }
        tabBarGutter={90}
        tabBarStyle={padfix}
      >
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>All</div>}
            key='all'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Upcoming</div>}
            key='upcoming'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>In-Development</div>}
            key='development'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>release</div>}
            key='release'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Active</div>}
            key='active'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Closed</div>}
            key='closed'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Checklist NA</div>}
            key='checklist_na'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Admin</div>}
            key='admin'
          />
        }
      </Tabs>
    </>
  );
}

export default ChecklistTabs;
